import { Fragment } from 'react'
import { ContentfulLivePreview } from '@contentful/live-preview'

import { LoopRotate } from '../../components/loop-rotate'
import { cn } from '../../utils/cn'
import { ButtonCms, ButtonCmsModel } from '../button/button.cms'
import { LogoCardCms } from '../cards/logo-card-cms'
import { BaseCMSGrid } from '../helper-components/base-grid'
import { RichText } from '../helper-components/rich-text'
import { TitleCms } from '../helper-components/title.cms'

const DEFAULT_NUMBER_OF_COLUMNS = 4

interface LayoutLogoListCmsProps {
  id: string
  isH1?: boolean
  layoutOption?: 'grid' | 'slider'
  title?: string | any
  collection: Array<any>
  numberOfColumns?: number
  interval?: number
  pageLink?: string
  button?: ButtonCmsModel | any
  paddingOnTop?: boolean
  paddingOnBottom?: boolean
}

export const LayoutLogoListCms = (props: LayoutLogoListCmsProps) => {
  function renderCard(card: any) {
    return (
      <LogoCardCms
        showBackground={true}
        card={card}
        layoutOption={props.layoutOption as string}
      />
    )
  }

  const renderCards = () => {
    return props.collection.map((item, i) => (
      <Fragment key={i}>{renderCard(item)}</Fragment>
    ))
  }

  return (
    <div
      className={cn(
        'my-6 text-center scroll-mt-25',
        props.paddingOnTop && 'pt-8 lg:pt-12',
        props.paddingOnBottom && 'pb-8 lg:pb-12'
      )}
      id={`${props.id}`}
    >
      {props.title && (
        <TitleCms
          aria-level={props.isH1 ? 1 : 2}
          {...ContentfulLivePreview.getProps({
            entryId: props.id,
            fieldId: 'title',
            locale: 'en-US',
          })}
        >
          <RichText json={props.title?.json} links={props.title?.links} />
        </TitleCms>
      )}

      {(props.layoutOption === 'grid' || !props.layoutOption) && (
        <BaseCMSGrid
          {...ContentfulLivePreview.getProps({
            entryId: props.id,
            fieldId: 'content',
            locale: 'en-US',
          })}
          numberOfColumns={props.numberOfColumns || DEFAULT_NUMBER_OF_COLUMNS}
          elements={renderCards()}
        />
      )}

      {props.layoutOption === 'slider' && (
        <LoopRotate
          speed={20}
          fadeEdges={true}
          {...ContentfulLivePreview.getProps({
            entryId: props.id,
            fieldId: 'content',
            locale: 'en-US',
          })}
        >
          <div className="flex gap-6 ">
            {props.collection.map((item, i) => (
              <div key={i} className="w-[18.75rem]">
                <LogoCardCms
                  showBackground={false}
                  card={item}
                  layoutOption={props.layoutOption as string}
                />
              </div>
            ))}
          </div>
        </LoopRotate>
      )}
      {props.button && (
        <div className="pt-9">
          <ButtonCms content={props.button} />
        </div>
      )}
    </div>
  )
}
